import { fromPickadate, now, toFormattedString
// @ts-expect-error: no types
} from 'UIComponents/core/SimpleDate';
import PortalIdParser from 'PortalIdParser';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
import { contentObjectToCrmObject } from 'framework-asset-preview-lib/internal/objectTypes/0-10/utils';
import cachedHttp from 'framework-asset-preview-lib/internal/shared/api/cachedHttp';
import { fetchCrmObjects } from 'framework-asset-preview-lib/internal/shared/api/crm';
import { getFormType } from './utils';
const WORKFLOW_REGEX = /\/workflows\/[0-9]+\/platform\/flow\/([0-9]+)\//;
const ANALYTICS_DATE_FORMAT = 'YYYYMMDD';
export function fetchFormDetails(crmObject) {
  const hsFormId = getPropertyValue(crmObject, 'hs_form_id');
  return cachedHttp.get(`forms/v2/forms/${hsFormId}`);
}
export function fetchFormAssociatedWorkflowsAsCrmObject(crmObject) {
  const hsFormId = getPropertyValue(crmObject, 'hs_form_id');
  const formType = getFormType(crmObject);
  if (formType == null) {
    return [];
  }
  return cachedHttp.get(`crm-usages/v2/usages/FORM/${formType}-${hsFormId}/parents/FLOW_ACTION`)
  // Get flowIds
  .then(response => response.map(workflow => {
    if (!WORKFLOW_REGEX.test(workflow.parentUsageUri)) {
      return null;
    }
    const regMatch = workflow.parentUsageUri.match(WORKFLOW_REGEX);
    if (!regMatch || !regMatch[1]) {
      return null;
    }
    return parseInt(regMatch[1], 10);
  }).filter(Boolean))
  // Fetch workflows from CRM
  .then(flowIds => {
    if (flowIds.length === 0) {
      return {
        hasMore: false,
        offset: 0,
        results: [],
        total: 0
      };
    }
    return fetchCrmObjects(OBJECT_TYPE.WORKFLOW, {
      filterGroups: [{
        filters: [{
          operator: 'IN',
          property: 'hs_flow_id',
          values: flowIds.map(flowId => String(flowId))
        }]
      }]
    });
  }).then(crmSearchResponse => crmSearchResponse.results);
}

/**
 * Forms uses a single endpoint to return all content object types.
 * This method returns a map per object type so we can correctly render each association type in the UI.
 */
export function fetchFormAssociatedPagesAsCrmObjects(crmObject) {
  const hsFormId = getPropertyValue(crmObject, 'hs_form_id');
  return cachedHttp.get('cosindex/api/v1/connections/parents', {
    query: {
      id: hsFormId,
      levels: 0,
      parentType: 'CONTENT'
    }
  }).then(response => {
    if (!(`${hsFormId}` in response)) {
      return {};
    }
    return response[`${hsFormId}`].reduce((acc, contentObject) => {
      let objectTypeId = '';
      switch (contentObject.subType) {
        default:
          break;
        case 'normal_blog_post':
          objectTypeId = OBJECT_TYPE.BLOG_POST;
          break;
        case 'landing_page':
          objectTypeId = OBJECT_TYPE.LANDING_PAGE;
          break;
        case 'site_page':
          objectTypeId = OBJECT_TYPE.SITE_PAGE;
          break;
      }
      if (!objectTypeId) {
        return acc;
      }
      acc[objectTypeId].push(contentObjectToCrmObject({
        objectId: parseInt(contentObject.id, 10),
        objectTypeId,
        portalId: PortalIdParser.get(),
        properties: {}
      }, contentObject.model));
      return acc;
    }, {
      [OBJECT_TYPE.BLOG_POST]: [],
      [OBJECT_TYPE.LANDING_PAGE]: [],
      [OBJECT_TYPE.SITE_PAGE]: []
    });
  });
}
export function fetchFormPerformance(crmObject) {
  const startDate = fromPickadate({
    year: 2000,
    month: 0,
    date: 1
  });
  return cachedHttp.get('activities/v2/forms/total', {
    query: {
      d1: getPropertyValue(crmObject, 'hs_form_id'),
      start: toFormattedString(startDate, ANALYTICS_DATE_FORMAT),
      end: toFormattedString(now(), ANALYTICS_DATE_FORMAT)
    }
  });
}
export function fetchFormFields(crmObject) {
  const hsFormId = getPropertyValue(crmObject, 'hs_form_id');
  return cachedHttp.get(`submissions/app/v1/submission-page/initialize/${hsFormId}`);
}